module.exports = __webpack_public_path__ + "media/theme/ico-select-b02c3520.svg";